import { helloDnaProfileState } from './hello-dna-profile.state';
import { helloDnaProfileActions } from './hello-dna-profile.action';
import { helloDnaProfileMutations } from './hello-dna-profile.mutation';

export default {
  namespaced: true,
  state: helloDnaProfileState,
  getters: {},
  actions: helloDnaProfileActions,
  mutations: helloDnaProfileMutations,
};
